import { Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import Typography from '../Typography/Typography'
import { isEmpty } from 'lodash'
import { IconButton } from '../../buttons'
import { IconButtonProps } from '../../buttons/IconButton/IconButton'

type IconButton = Omit<IconButtonProps, 'size' | 'variant'>

type HeadlineProps = {
    title: string
    variant: 'headline1' | 'headline2' | 'headline3' | 'headline4' | 'headline5'
    fullWidth?: boolean
    withSpacing?: boolean
    iconButtons?: IconButton[]
}

export function Headline({ title, variant, fullWidth = true, withSpacing, iconButtons }: HeadlineProps) {
    const getBottomSpacing = () => {
        if (withSpacing) {
            if (variant === 'headline1') {
                return tokens.SizingSpacing200
            }
            return tokens.SizingSpacing150
        }
    }
    return (
        <Stack
            direction="row"
            gap={tokens.SizingSpacing075}
            alignItems="center"
            justifyContent="space-between"
            width={fullWidth ? '100%' : 'fit-content'}
            marginBottom={getBottomSpacing()}
            height={variant === 'headline1' || variant === 'headline2' ? '40px' : '32px'}
        >
            <Typography variant={variant} color={tokens.ColorTextBoldest} noWrap>
                {title}
            </Typography>
            {!isEmpty(iconButtons) && (
                <Stack direction="row">
                    {iconButtons?.map((iconButton, index) => (
                        <IconButton
                            size={variant === 'headline1' || variant === 'headline2' ? 'medium' : 'small'}
                            variant="tertiary"
                            key={`${title} iconButton ${index}`}
                            {...iconButton}
                        />
                    ))}
                </Stack>
            )}
        </Stack>
    )
}
